/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as EnrolRouteImport } from './routes/enrol'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PasswordResetRouteImport } from './routes/password-reset'
import { Route as AdminIndexRouteImport } from './routes/_admin/index'
import { Route as AdminAccountIndexRouteImport } from './routes/_admin/account/index'
import { Route as AdminContentIndexRouteImport } from './routes/_admin/content/index'
import { Route as AdminCustomerIndexRouteImport } from './routes/_admin/customer/index'
import { Route as AdminCustomerCustomerIdRouteImport } from './routes/_admin/customer/$customerId'
import { Route as AdminDiscountCodeIndexRouteImport } from './routes/_admin/discount-code/index'
import { Route as AdminDiscountCodeIdRouteImport } from './routes/_admin/discount-code/$id'
import { Route as AdminDiscountCodeNewRouteImport } from './routes/_admin/discount-code/new'
import { Route as AdminOrderIndexRouteImport } from './routes/_admin/order/index'
import { Route as AdminOrderOrderIdRouteImport } from './routes/_admin/order/$orderId'
import { Route as AdminOrderInvoicesRouteImport } from './routes/_admin/order/invoices'
import { Route as AdminProductReviewIndexRouteImport } from './routes/_admin/product-review/index'
import { Route as AdminProductReviewReviewIdRouteImport } from './routes/_admin/product-review/$reviewId'
import { Route as AdminProductIndexRouteImport } from './routes/_admin/product/index'
import { Route as AdminProductProductIdRouteImport } from './routes/_admin/product/$productId'
import { Route as AdminProductNewRouteImport } from './routes/_admin/product/new'
import { Route as AdminRevenueIndexRouteImport } from './routes/_admin/revenue/index'
import { Route as AdminSettingsIndexRouteImport } from './routes/_admin/settings/index'
import { Route as AdminStockIndexRouteImport } from './routes/_admin/stock/index'
import { Route as AdminStockVariantIdRouteImport } from './routes/_admin/stock/$variantId'
import { Route as AdminStockQuickRouteImport } from './routes/_admin/stock/quick'
import { Route as AdminContentFaqIndexRouteImport } from './routes/_admin/content/faq/index'
import { Route as AdminContentFaqIdRouteImport } from './routes/_admin/content/faq/$id'
import { Route as AdminContentFaqNewRouteImport } from './routes/_admin/content/faq/new'
import { Route as AdminContentNewsletterIndexRouteImport } from './routes/_admin/content/newsletter/index'
import { Route as AdminContentPagesIndexRouteImport } from './routes/_admin/content/pages/index'
import { Route as AdminContentPagesIdRouteImport } from './routes/_admin/content/pages/$id'
import { Route as AdminContentPagesNewRouteImport } from './routes/_admin/content/pages/new'
import { Route as AdminProductAttributeIndexRouteImport } from './routes/_admin/product/attribute/index'
import { Route as AdminProductCategoryIndexRouteImport } from './routes/_admin/product/category/index'
import { Route as AdminProductHolderIndexRouteImport } from './routes/_admin/product/holder/index'
import { Route as AdminProductLineIndexRouteImport } from './routes/_admin/product/line/index'
import { Route as AdminSettingsCompanyDetailsIndexRouteImport } from './routes/_admin/settings/company-details/index'
import { Route as AdminSettingsCustomerGroupIndexRouteImport } from './routes/_admin/settings/customer-group/index'
import { Route as AdminSettingsEmployeeIndexRouteImport } from './routes/_admin/settings/employee/index'
import { Route as AdminSettingsEmployeeIdRouteImport } from './routes/_admin/settings/employee/$id'
import { Route as AdminSettingsEmployeeNewRouteImport } from './routes/_admin/settings/employee/new'
import { Route as AdminSettingsLocationIndexRouteImport } from './routes/_admin/settings/location/index'
import { Route as AdminSettingsShippingRuleIndexRouteImport } from './routes/_admin/settings/shipping-rule/index'
import { Route as AdminSettingsTokenIndexRouteImport } from './routes/_admin/settings/token/index'

const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const EnrolRoute = EnrolRouteImport.update({
  id: '/enrol',
  path: '/enrol',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetRoute = PasswordResetRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAccountIndexRoute = AdminAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminContentIndexRoute = AdminContentIndexRouteImport.update({
  id: '/content/',
  path: '/content/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCustomerIndexRoute = AdminCustomerIndexRouteImport.update({
  id: '/customer/',
  path: '/customer/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCustomerCustomerIdRoute = AdminCustomerCustomerIdRouteImport.update({
  id: '/customer/$customerId',
  path: '/customer/$customerId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDiscountCodeIndexRoute = AdminDiscountCodeIndexRouteImport.update({
  id: '/discount-code/',
  path: '/discount-code/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDiscountCodeIdRoute = AdminDiscountCodeIdRouteImport.update({
  id: '/discount-code/$id',
  path: '/discount-code/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDiscountCodeNewRoute = AdminDiscountCodeNewRouteImport.update({
  id: '/discount-code/new',
  path: '/discount-code/new',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrderIndexRoute = AdminOrderIndexRouteImport.update({
  id: '/order/',
  path: '/order/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrderOrderIdRoute = AdminOrderOrderIdRouteImport.update({
  id: '/order/$orderId',
  path: '/order/$orderId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrderInvoicesRoute = AdminOrderInvoicesRouteImport.update({
  id: '/order/invoices',
  path: '/order/invoices',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProductReviewIndexRoute = AdminProductReviewIndexRouteImport.update({
  id: '/product-review/',
  path: '/product-review/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProductReviewReviewIdRoute =
  AdminProductReviewReviewIdRouteImport.update({
    id: '/product-review/$reviewId',
    path: '/product-review/$reviewId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminProductIndexRoute = AdminProductIndexRouteImport.update({
  id: '/product/',
  path: '/product/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProductProductIdRoute = AdminProductProductIdRouteImport.update({
  id: '/product/$productId',
  path: '/product/$productId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProductNewRoute = AdminProductNewRouteImport.update({
  id: '/product/new',
  path: '/product/new',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRevenueIndexRoute = AdminRevenueIndexRouteImport.update({
  id: '/revenue/',
  path: '/revenue/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsIndexRoute = AdminSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStockIndexRoute = AdminStockIndexRouteImport.update({
  id: '/stock/',
  path: '/stock/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStockVariantIdRoute = AdminStockVariantIdRouteImport.update({
  id: '/stock/$variantId',
  path: '/stock/$variantId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStockQuickRoute = AdminStockQuickRouteImport.update({
  id: '/stock/quick',
  path: '/stock/quick',
  getParentRoute: () => AdminRoute,
} as any)
const AdminContentFaqIndexRoute = AdminContentFaqIndexRouteImport.update({
  id: '/content/faq/',
  path: '/content/faq/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminContentFaqIdRoute = AdminContentFaqIdRouteImport.update({
  id: '/content/faq/$id',
  path: '/content/faq/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminContentFaqNewRoute = AdminContentFaqNewRouteImport.update({
  id: '/content/faq/new',
  path: '/content/faq/new',
  getParentRoute: () => AdminRoute,
} as any)
const AdminContentNewsletterIndexRoute =
  AdminContentNewsletterIndexRouteImport.update({
    id: '/content/newsletter/',
    path: '/content/newsletter/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminContentPagesIndexRoute = AdminContentPagesIndexRouteImport.update({
  id: '/content/pages/',
  path: '/content/pages/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminContentPagesIdRoute = AdminContentPagesIdRouteImport.update({
  id: '/content/pages/$id',
  path: '/content/pages/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminContentPagesNewRoute = AdminContentPagesNewRouteImport.update({
  id: '/content/pages/new',
  path: '/content/pages/new',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProductAttributeIndexRoute =
  AdminProductAttributeIndexRouteImport.update({
    id: '/product/attribute/',
    path: '/product/attribute/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminProductCategoryIndexRoute =
  AdminProductCategoryIndexRouteImport.update({
    id: '/product/category/',
    path: '/product/category/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminProductHolderIndexRoute = AdminProductHolderIndexRouteImport.update({
  id: '/product/holder/',
  path: '/product/holder/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProductLineIndexRoute = AdminProductLineIndexRouteImport.update({
  id: '/product/line/',
  path: '/product/line/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsCompanyDetailsIndexRoute =
  AdminSettingsCompanyDetailsIndexRouteImport.update({
    id: '/settings/company-details/',
    path: '/settings/company-details/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminSettingsCustomerGroupIndexRoute =
  AdminSettingsCustomerGroupIndexRouteImport.update({
    id: '/settings/customer-group/',
    path: '/settings/customer-group/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminSettingsEmployeeIndexRoute =
  AdminSettingsEmployeeIndexRouteImport.update({
    id: '/settings/employee/',
    path: '/settings/employee/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminSettingsEmployeeIdRoute = AdminSettingsEmployeeIdRouteImport.update({
  id: '/settings/employee/$id',
  path: '/settings/employee/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsEmployeeNewRoute =
  AdminSettingsEmployeeNewRouteImport.update({
    id: '/settings/employee/new',
    path: '/settings/employee/new',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminSettingsLocationIndexRoute =
  AdminSettingsLocationIndexRouteImport.update({
    id: '/settings/location/',
    path: '/settings/location/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminSettingsShippingRuleIndexRoute =
  AdminSettingsShippingRuleIndexRouteImport.update({
    id: '/settings/shipping-rule/',
    path: '/settings/shipping-rule/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminSettingsTokenIndexRoute = AdminSettingsTokenIndexRouteImport.update({
  id: '/settings/token/',
  path: '/settings/token/',
  getParentRoute: () => AdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AdminIndexRoute
  '/enrol': typeof EnrolRoute
  '/login': typeof LoginRoute
  '/password-reset': typeof PasswordResetRoute
  '/customer/$customerId': typeof AdminCustomerCustomerIdRoute
  '/discount-code/$id': typeof AdminDiscountCodeIdRoute
  '/discount-code/new': typeof AdminDiscountCodeNewRoute
  '/order/$orderId': typeof AdminOrderOrderIdRoute
  '/order/invoices': typeof AdminOrderInvoicesRoute
  '/product-review/$reviewId': typeof AdminProductReviewReviewIdRoute
  '/product/$productId': typeof AdminProductProductIdRoute
  '/product/new': typeof AdminProductNewRoute
  '/stock/$variantId': typeof AdminStockVariantIdRoute
  '/stock/quick': typeof AdminStockQuickRoute
  '/account/': typeof AdminAccountIndexRoute
  '/content/': typeof AdminContentIndexRoute
  '/customer/': typeof AdminCustomerIndexRoute
  '/discount-code/': typeof AdminDiscountCodeIndexRoute
  '/order/': typeof AdminOrderIndexRoute
  '/product-review/': typeof AdminProductReviewIndexRoute
  '/product/': typeof AdminProductIndexRoute
  '/revenue/': typeof AdminRevenueIndexRoute
  '/settings/': typeof AdminSettingsIndexRoute
  '/stock/': typeof AdminStockIndexRoute
  '/content/faq/$id': typeof AdminContentFaqIdRoute
  '/content/faq/new': typeof AdminContentFaqNewRoute
  '/content/pages/$id': typeof AdminContentPagesIdRoute
  '/content/pages/new': typeof AdminContentPagesNewRoute
  '/settings/employee/$id': typeof AdminSettingsEmployeeIdRoute
  '/settings/employee/new': typeof AdminSettingsEmployeeNewRoute
  '/content/faq/': typeof AdminContentFaqIndexRoute
  '/content/newsletter/': typeof AdminContentNewsletterIndexRoute
  '/content/pages/': typeof AdminContentPagesIndexRoute
  '/product/attribute/': typeof AdminProductAttributeIndexRoute
  '/product/category/': typeof AdminProductCategoryIndexRoute
  '/product/holder/': typeof AdminProductHolderIndexRoute
  '/product/line/': typeof AdminProductLineIndexRoute
  '/settings/company-details/': typeof AdminSettingsCompanyDetailsIndexRoute
  '/settings/customer-group/': typeof AdminSettingsCustomerGroupIndexRoute
  '/settings/employee/': typeof AdminSettingsEmployeeIndexRoute
  '/settings/location/': typeof AdminSettingsLocationIndexRoute
  '/settings/shipping-rule/': typeof AdminSettingsShippingRuleIndexRoute
  '/settings/token/': typeof AdminSettingsTokenIndexRoute
}
export interface FileRoutesByTo {
  '/enrol': typeof EnrolRoute
  '/login': typeof LoginRoute
  '/password-reset': typeof PasswordResetRoute
  '/': typeof AdminIndexRoute
  '/customer/$customerId': typeof AdminCustomerCustomerIdRoute
  '/discount-code/$id': typeof AdminDiscountCodeIdRoute
  '/discount-code/new': typeof AdminDiscountCodeNewRoute
  '/order/$orderId': typeof AdminOrderOrderIdRoute
  '/order/invoices': typeof AdminOrderInvoicesRoute
  '/product-review/$reviewId': typeof AdminProductReviewReviewIdRoute
  '/product/$productId': typeof AdminProductProductIdRoute
  '/product/new': typeof AdminProductNewRoute
  '/stock/$variantId': typeof AdminStockVariantIdRoute
  '/stock/quick': typeof AdminStockQuickRoute
  '/account': typeof AdminAccountIndexRoute
  '/content': typeof AdminContentIndexRoute
  '/customer': typeof AdminCustomerIndexRoute
  '/discount-code': typeof AdminDiscountCodeIndexRoute
  '/order': typeof AdminOrderIndexRoute
  '/product-review': typeof AdminProductReviewIndexRoute
  '/product': typeof AdminProductIndexRoute
  '/revenue': typeof AdminRevenueIndexRoute
  '/settings': typeof AdminSettingsIndexRoute
  '/stock': typeof AdminStockIndexRoute
  '/content/faq/$id': typeof AdminContentFaqIdRoute
  '/content/faq/new': typeof AdminContentFaqNewRoute
  '/content/pages/$id': typeof AdminContentPagesIdRoute
  '/content/pages/new': typeof AdminContentPagesNewRoute
  '/settings/employee/$id': typeof AdminSettingsEmployeeIdRoute
  '/settings/employee/new': typeof AdminSettingsEmployeeNewRoute
  '/content/faq': typeof AdminContentFaqIndexRoute
  '/content/newsletter': typeof AdminContentNewsletterIndexRoute
  '/content/pages': typeof AdminContentPagesIndexRoute
  '/product/attribute': typeof AdminProductAttributeIndexRoute
  '/product/category': typeof AdminProductCategoryIndexRoute
  '/product/holder': typeof AdminProductHolderIndexRoute
  '/product/line': typeof AdminProductLineIndexRoute
  '/settings/company-details': typeof AdminSettingsCompanyDetailsIndexRoute
  '/settings/customer-group': typeof AdminSettingsCustomerGroupIndexRoute
  '/settings/employee': typeof AdminSettingsEmployeeIndexRoute
  '/settings/location': typeof AdminSettingsLocationIndexRoute
  '/settings/shipping-rule': typeof AdminSettingsShippingRuleIndexRoute
  '/settings/token': typeof AdminSettingsTokenIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_admin': typeof AdminRouteWithChildren
  '/enrol': typeof EnrolRoute
  '/login': typeof LoginRoute
  '/password-reset': typeof PasswordResetRoute
  '/_admin/': typeof AdminIndexRoute
  '/_admin/customer/$customerId': typeof AdminCustomerCustomerIdRoute
  '/_admin/discount-code/$id': typeof AdminDiscountCodeIdRoute
  '/_admin/discount-code/new': typeof AdminDiscountCodeNewRoute
  '/_admin/order/$orderId': typeof AdminOrderOrderIdRoute
  '/_admin/order/invoices': typeof AdminOrderInvoicesRoute
  '/_admin/product-review/$reviewId': typeof AdminProductReviewReviewIdRoute
  '/_admin/product/$productId': typeof AdminProductProductIdRoute
  '/_admin/product/new': typeof AdminProductNewRoute
  '/_admin/stock/$variantId': typeof AdminStockVariantIdRoute
  '/_admin/stock/quick': typeof AdminStockQuickRoute
  '/_admin/account/': typeof AdminAccountIndexRoute
  '/_admin/content/': typeof AdminContentIndexRoute
  '/_admin/customer/': typeof AdminCustomerIndexRoute
  '/_admin/discount-code/': typeof AdminDiscountCodeIndexRoute
  '/_admin/order/': typeof AdminOrderIndexRoute
  '/_admin/product-review/': typeof AdminProductReviewIndexRoute
  '/_admin/product/': typeof AdminProductIndexRoute
  '/_admin/revenue/': typeof AdminRevenueIndexRoute
  '/_admin/settings/': typeof AdminSettingsIndexRoute
  '/_admin/stock/': typeof AdminStockIndexRoute
  '/_admin/content/faq/$id': typeof AdminContentFaqIdRoute
  '/_admin/content/faq/new': typeof AdminContentFaqNewRoute
  '/_admin/content/pages/$id': typeof AdminContentPagesIdRoute
  '/_admin/content/pages/new': typeof AdminContentPagesNewRoute
  '/_admin/settings/employee/$id': typeof AdminSettingsEmployeeIdRoute
  '/_admin/settings/employee/new': typeof AdminSettingsEmployeeNewRoute
  '/_admin/content/faq/': typeof AdminContentFaqIndexRoute
  '/_admin/content/newsletter/': typeof AdminContentNewsletterIndexRoute
  '/_admin/content/pages/': typeof AdminContentPagesIndexRoute
  '/_admin/product/attribute/': typeof AdminProductAttributeIndexRoute
  '/_admin/product/category/': typeof AdminProductCategoryIndexRoute
  '/_admin/product/holder/': typeof AdminProductHolderIndexRoute
  '/_admin/product/line/': typeof AdminProductLineIndexRoute
  '/_admin/settings/company-details/': typeof AdminSettingsCompanyDetailsIndexRoute
  '/_admin/settings/customer-group/': typeof AdminSettingsCustomerGroupIndexRoute
  '/_admin/settings/employee/': typeof AdminSettingsEmployeeIndexRoute
  '/_admin/settings/location/': typeof AdminSettingsLocationIndexRoute
  '/_admin/settings/shipping-rule/': typeof AdminSettingsShippingRuleIndexRoute
  '/_admin/settings/token/': typeof AdminSettingsTokenIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/enrol'
    | '/login'
    | '/password-reset'
    | '/customer/$customerId'
    | '/discount-code/$id'
    | '/discount-code/new'
    | '/order/$orderId'
    | '/order/invoices'
    | '/product-review/$reviewId'
    | '/product/$productId'
    | '/product/new'
    | '/stock/$variantId'
    | '/stock/quick'
    | '/account/'
    | '/content/'
    | '/customer/'
    | '/discount-code/'
    | '/order/'
    | '/product-review/'
    | '/product/'
    | '/revenue/'
    | '/settings/'
    | '/stock/'
    | '/content/faq/$id'
    | '/content/faq/new'
    | '/content/pages/$id'
    | '/content/pages/new'
    | '/settings/employee/$id'
    | '/settings/employee/new'
    | '/content/faq/'
    | '/content/newsletter/'
    | '/content/pages/'
    | '/product/attribute/'
    | '/product/category/'
    | '/product/holder/'
    | '/product/line/'
    | '/settings/company-details/'
    | '/settings/customer-group/'
    | '/settings/employee/'
    | '/settings/location/'
    | '/settings/shipping-rule/'
    | '/settings/token/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/enrol'
    | '/login'
    | '/password-reset'
    | '/'
    | '/customer/$customerId'
    | '/discount-code/$id'
    | '/discount-code/new'
    | '/order/$orderId'
    | '/order/invoices'
    | '/product-review/$reviewId'
    | '/product/$productId'
    | '/product/new'
    | '/stock/$variantId'
    | '/stock/quick'
    | '/account'
    | '/content'
    | '/customer'
    | '/discount-code'
    | '/order'
    | '/product-review'
    | '/product'
    | '/revenue'
    | '/settings'
    | '/stock'
    | '/content/faq/$id'
    | '/content/faq/new'
    | '/content/pages/$id'
    | '/content/pages/new'
    | '/settings/employee/$id'
    | '/settings/employee/new'
    | '/content/faq'
    | '/content/newsletter'
    | '/content/pages'
    | '/product/attribute'
    | '/product/category'
    | '/product/holder'
    | '/product/line'
    | '/settings/company-details'
    | '/settings/customer-group'
    | '/settings/employee'
    | '/settings/location'
    | '/settings/shipping-rule'
    | '/settings/token'
  id:
    | '__root__'
    | '/_admin'
    | '/enrol'
    | '/login'
    | '/password-reset'
    | '/_admin/'
    | '/_admin/customer/$customerId'
    | '/_admin/discount-code/$id'
    | '/_admin/discount-code/new'
    | '/_admin/order/$orderId'
    | '/_admin/order/invoices'
    | '/_admin/product-review/$reviewId'
    | '/_admin/product/$productId'
    | '/_admin/product/new'
    | '/_admin/stock/$variantId'
    | '/_admin/stock/quick'
    | '/_admin/account/'
    | '/_admin/content/'
    | '/_admin/customer/'
    | '/_admin/discount-code/'
    | '/_admin/order/'
    | '/_admin/product-review/'
    | '/_admin/product/'
    | '/_admin/revenue/'
    | '/_admin/settings/'
    | '/_admin/stock/'
    | '/_admin/content/faq/$id'
    | '/_admin/content/faq/new'
    | '/_admin/content/pages/$id'
    | '/_admin/content/pages/new'
    | '/_admin/settings/employee/$id'
    | '/_admin/settings/employee/new'
    | '/_admin/content/faq/'
    | '/_admin/content/newsletter/'
    | '/_admin/content/pages/'
    | '/_admin/product/attribute/'
    | '/_admin/product/category/'
    | '/_admin/product/holder/'
    | '/_admin/product/line/'
    | '/_admin/settings/company-details/'
    | '/_admin/settings/customer-group/'
    | '/_admin/settings/employee/'
    | '/_admin/settings/location/'
    | '/_admin/settings/shipping-rule/'
    | '/_admin/settings/token/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AdminRoute: typeof AdminRouteWithChildren
  EnrolRoute: typeof EnrolRoute
  LoginRoute: typeof LoginRoute
  PasswordResetRoute: typeof PasswordResetRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/enrol': {
      id: '/enrol'
      path: '/enrol'
      fullPath: '/enrol'
      preLoaderRoute: typeof EnrolRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password-reset': {
      id: '/password-reset'
      path: '/password-reset'
      fullPath: '/password-reset'
      preLoaderRoute: typeof PasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/': {
      id: '/_admin/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/account/': {
      id: '/_admin/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof AdminAccountIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/content/': {
      id: '/_admin/content/'
      path: '/content'
      fullPath: '/content/'
      preLoaderRoute: typeof AdminContentIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/customer/': {
      id: '/_admin/customer/'
      path: '/customer'
      fullPath: '/customer/'
      preLoaderRoute: typeof AdminCustomerIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/customer/$customerId': {
      id: '/_admin/customer/$customerId'
      path: '/customer/$customerId'
      fullPath: '/customer/$customerId'
      preLoaderRoute: typeof AdminCustomerCustomerIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/discount-code/': {
      id: '/_admin/discount-code/'
      path: '/discount-code'
      fullPath: '/discount-code/'
      preLoaderRoute: typeof AdminDiscountCodeIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/discount-code/$id': {
      id: '/_admin/discount-code/$id'
      path: '/discount-code/$id'
      fullPath: '/discount-code/$id'
      preLoaderRoute: typeof AdminDiscountCodeIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/discount-code/new': {
      id: '/_admin/discount-code/new'
      path: '/discount-code/new'
      fullPath: '/discount-code/new'
      preLoaderRoute: typeof AdminDiscountCodeNewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/order/': {
      id: '/_admin/order/'
      path: '/order'
      fullPath: '/order/'
      preLoaderRoute: typeof AdminOrderIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/order/$orderId': {
      id: '/_admin/order/$orderId'
      path: '/order/$orderId'
      fullPath: '/order/$orderId'
      preLoaderRoute: typeof AdminOrderOrderIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/order/invoices': {
      id: '/_admin/order/invoices'
      path: '/order/invoices'
      fullPath: '/order/invoices'
      preLoaderRoute: typeof AdminOrderInvoicesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/product-review/': {
      id: '/_admin/product-review/'
      path: '/product-review'
      fullPath: '/product-review/'
      preLoaderRoute: typeof AdminProductReviewIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/product-review/$reviewId': {
      id: '/_admin/product-review/$reviewId'
      path: '/product-review/$reviewId'
      fullPath: '/product-review/$reviewId'
      preLoaderRoute: typeof AdminProductReviewReviewIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/product/': {
      id: '/_admin/product/'
      path: '/product'
      fullPath: '/product/'
      preLoaderRoute: typeof AdminProductIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/product/$productId': {
      id: '/_admin/product/$productId'
      path: '/product/$productId'
      fullPath: '/product/$productId'
      preLoaderRoute: typeof AdminProductProductIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/product/new': {
      id: '/_admin/product/new'
      path: '/product/new'
      fullPath: '/product/new'
      preLoaderRoute: typeof AdminProductNewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/revenue/': {
      id: '/_admin/revenue/'
      path: '/revenue'
      fullPath: '/revenue/'
      preLoaderRoute: typeof AdminRevenueIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/settings/': {
      id: '/_admin/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AdminSettingsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/stock/': {
      id: '/_admin/stock/'
      path: '/stock'
      fullPath: '/stock/'
      preLoaderRoute: typeof AdminStockIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/stock/$variantId': {
      id: '/_admin/stock/$variantId'
      path: '/stock/$variantId'
      fullPath: '/stock/$variantId'
      preLoaderRoute: typeof AdminStockVariantIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/stock/quick': {
      id: '/_admin/stock/quick'
      path: '/stock/quick'
      fullPath: '/stock/quick'
      preLoaderRoute: typeof AdminStockQuickRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/content/faq/': {
      id: '/_admin/content/faq/'
      path: '/content/faq'
      fullPath: '/content/faq/'
      preLoaderRoute: typeof AdminContentFaqIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/content/faq/$id': {
      id: '/_admin/content/faq/$id'
      path: '/content/faq/$id'
      fullPath: '/content/faq/$id'
      preLoaderRoute: typeof AdminContentFaqIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/content/faq/new': {
      id: '/_admin/content/faq/new'
      path: '/content/faq/new'
      fullPath: '/content/faq/new'
      preLoaderRoute: typeof AdminContentFaqNewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/content/newsletter/': {
      id: '/_admin/content/newsletter/'
      path: '/content/newsletter'
      fullPath: '/content/newsletter/'
      preLoaderRoute: typeof AdminContentNewsletterIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/content/pages/': {
      id: '/_admin/content/pages/'
      path: '/content/pages'
      fullPath: '/content/pages/'
      preLoaderRoute: typeof AdminContentPagesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/content/pages/$id': {
      id: '/_admin/content/pages/$id'
      path: '/content/pages/$id'
      fullPath: '/content/pages/$id'
      preLoaderRoute: typeof AdminContentPagesIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/content/pages/new': {
      id: '/_admin/content/pages/new'
      path: '/content/pages/new'
      fullPath: '/content/pages/new'
      preLoaderRoute: typeof AdminContentPagesNewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/product/attribute/': {
      id: '/_admin/product/attribute/'
      path: '/product/attribute'
      fullPath: '/product/attribute/'
      preLoaderRoute: typeof AdminProductAttributeIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/product/category/': {
      id: '/_admin/product/category/'
      path: '/product/category'
      fullPath: '/product/category/'
      preLoaderRoute: typeof AdminProductCategoryIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/product/holder/': {
      id: '/_admin/product/holder/'
      path: '/product/holder'
      fullPath: '/product/holder/'
      preLoaderRoute: typeof AdminProductHolderIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/product/line/': {
      id: '/_admin/product/line/'
      path: '/product/line'
      fullPath: '/product/line/'
      preLoaderRoute: typeof AdminProductLineIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/settings/company-details/': {
      id: '/_admin/settings/company-details/'
      path: '/settings/company-details'
      fullPath: '/settings/company-details/'
      preLoaderRoute: typeof AdminSettingsCompanyDetailsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/settings/customer-group/': {
      id: '/_admin/settings/customer-group/'
      path: '/settings/customer-group'
      fullPath: '/settings/customer-group/'
      preLoaderRoute: typeof AdminSettingsCustomerGroupIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/settings/employee/': {
      id: '/_admin/settings/employee/'
      path: '/settings/employee'
      fullPath: '/settings/employee/'
      preLoaderRoute: typeof AdminSettingsEmployeeIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/settings/employee/$id': {
      id: '/_admin/settings/employee/$id'
      path: '/settings/employee/$id'
      fullPath: '/settings/employee/$id'
      preLoaderRoute: typeof AdminSettingsEmployeeIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/settings/employee/new': {
      id: '/_admin/settings/employee/new'
      path: '/settings/employee/new'
      fullPath: '/settings/employee/new'
      preLoaderRoute: typeof AdminSettingsEmployeeNewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/settings/location/': {
      id: '/_admin/settings/location/'
      path: '/settings/location'
      fullPath: '/settings/location/'
      preLoaderRoute: typeof AdminSettingsLocationIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/settings/shipping-rule/': {
      id: '/_admin/settings/shipping-rule/'
      path: '/settings/shipping-rule'
      fullPath: '/settings/shipping-rule/'
      preLoaderRoute: typeof AdminSettingsShippingRuleIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/settings/token/': {
      id: '/_admin/settings/token/'
      path: '/settings/token'
      fullPath: '/settings/token/'
      preLoaderRoute: typeof AdminSettingsTokenIndexRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminIndexRoute: typeof AdminIndexRoute
  AdminCustomerCustomerIdRoute: typeof AdminCustomerCustomerIdRoute
  AdminDiscountCodeIdRoute: typeof AdminDiscountCodeIdRoute
  AdminDiscountCodeNewRoute: typeof AdminDiscountCodeNewRoute
  AdminOrderOrderIdRoute: typeof AdminOrderOrderIdRoute
  AdminOrderInvoicesRoute: typeof AdminOrderInvoicesRoute
  AdminProductReviewReviewIdRoute: typeof AdminProductReviewReviewIdRoute
  AdminProductProductIdRoute: typeof AdminProductProductIdRoute
  AdminProductNewRoute: typeof AdminProductNewRoute
  AdminStockVariantIdRoute: typeof AdminStockVariantIdRoute
  AdminStockQuickRoute: typeof AdminStockQuickRoute
  AdminAccountIndexRoute: typeof AdminAccountIndexRoute
  AdminContentIndexRoute: typeof AdminContentIndexRoute
  AdminCustomerIndexRoute: typeof AdminCustomerIndexRoute
  AdminDiscountCodeIndexRoute: typeof AdminDiscountCodeIndexRoute
  AdminOrderIndexRoute: typeof AdminOrderIndexRoute
  AdminProductReviewIndexRoute: typeof AdminProductReviewIndexRoute
  AdminProductIndexRoute: typeof AdminProductIndexRoute
  AdminRevenueIndexRoute: typeof AdminRevenueIndexRoute
  AdminSettingsIndexRoute: typeof AdminSettingsIndexRoute
  AdminStockIndexRoute: typeof AdminStockIndexRoute
  AdminContentFaqIdRoute: typeof AdminContentFaqIdRoute
  AdminContentFaqNewRoute: typeof AdminContentFaqNewRoute
  AdminContentPagesIdRoute: typeof AdminContentPagesIdRoute
  AdminContentPagesNewRoute: typeof AdminContentPagesNewRoute
  AdminSettingsEmployeeIdRoute: typeof AdminSettingsEmployeeIdRoute
  AdminSettingsEmployeeNewRoute: typeof AdminSettingsEmployeeNewRoute
  AdminContentFaqIndexRoute: typeof AdminContentFaqIndexRoute
  AdminContentNewsletterIndexRoute: typeof AdminContentNewsletterIndexRoute
  AdminContentPagesIndexRoute: typeof AdminContentPagesIndexRoute
  AdminProductAttributeIndexRoute: typeof AdminProductAttributeIndexRoute
  AdminProductCategoryIndexRoute: typeof AdminProductCategoryIndexRoute
  AdminProductHolderIndexRoute: typeof AdminProductHolderIndexRoute
  AdminProductLineIndexRoute: typeof AdminProductLineIndexRoute
  AdminSettingsCompanyDetailsIndexRoute: typeof AdminSettingsCompanyDetailsIndexRoute
  AdminSettingsCustomerGroupIndexRoute: typeof AdminSettingsCustomerGroupIndexRoute
  AdminSettingsEmployeeIndexRoute: typeof AdminSettingsEmployeeIndexRoute
  AdminSettingsLocationIndexRoute: typeof AdminSettingsLocationIndexRoute
  AdminSettingsShippingRuleIndexRoute: typeof AdminSettingsShippingRuleIndexRoute
  AdminSettingsTokenIndexRoute: typeof AdminSettingsTokenIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminIndexRoute: AdminIndexRoute,
  AdminCustomerCustomerIdRoute: AdminCustomerCustomerIdRoute,
  AdminDiscountCodeIdRoute: AdminDiscountCodeIdRoute,
  AdminDiscountCodeNewRoute: AdminDiscountCodeNewRoute,
  AdminOrderOrderIdRoute: AdminOrderOrderIdRoute,
  AdminOrderInvoicesRoute: AdminOrderInvoicesRoute,
  AdminProductReviewReviewIdRoute: AdminProductReviewReviewIdRoute,
  AdminProductProductIdRoute: AdminProductProductIdRoute,
  AdminProductNewRoute: AdminProductNewRoute,
  AdminStockVariantIdRoute: AdminStockVariantIdRoute,
  AdminStockQuickRoute: AdminStockQuickRoute,
  AdminAccountIndexRoute: AdminAccountIndexRoute,
  AdminContentIndexRoute: AdminContentIndexRoute,
  AdminCustomerIndexRoute: AdminCustomerIndexRoute,
  AdminDiscountCodeIndexRoute: AdminDiscountCodeIndexRoute,
  AdminOrderIndexRoute: AdminOrderIndexRoute,
  AdminProductReviewIndexRoute: AdminProductReviewIndexRoute,
  AdminProductIndexRoute: AdminProductIndexRoute,
  AdminRevenueIndexRoute: AdminRevenueIndexRoute,
  AdminSettingsIndexRoute: AdminSettingsIndexRoute,
  AdminStockIndexRoute: AdminStockIndexRoute,
  AdminContentFaqIdRoute: AdminContentFaqIdRoute,
  AdminContentFaqNewRoute: AdminContentFaqNewRoute,
  AdminContentPagesIdRoute: AdminContentPagesIdRoute,
  AdminContentPagesNewRoute: AdminContentPagesNewRoute,
  AdminSettingsEmployeeIdRoute: AdminSettingsEmployeeIdRoute,
  AdminSettingsEmployeeNewRoute: AdminSettingsEmployeeNewRoute,
  AdminContentFaqIndexRoute: AdminContentFaqIndexRoute,
  AdminContentNewsletterIndexRoute: AdminContentNewsletterIndexRoute,
  AdminContentPagesIndexRoute: AdminContentPagesIndexRoute,
  AdminProductAttributeIndexRoute: AdminProductAttributeIndexRoute,
  AdminProductCategoryIndexRoute: AdminProductCategoryIndexRoute,
  AdminProductHolderIndexRoute: AdminProductHolderIndexRoute,
  AdminProductLineIndexRoute: AdminProductLineIndexRoute,
  AdminSettingsCompanyDetailsIndexRoute: AdminSettingsCompanyDetailsIndexRoute,
  AdminSettingsCustomerGroupIndexRoute: AdminSettingsCustomerGroupIndexRoute,
  AdminSettingsEmployeeIndexRoute: AdminSettingsEmployeeIndexRoute,
  AdminSettingsLocationIndexRoute: AdminSettingsLocationIndexRoute,
  AdminSettingsShippingRuleIndexRoute: AdminSettingsShippingRuleIndexRoute,
  AdminSettingsTokenIndexRoute: AdminSettingsTokenIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AdminRoute: AdminRouteWithChildren,
  EnrolRoute: EnrolRoute,
  LoginRoute: LoginRoute,
  PasswordResetRoute: PasswordResetRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
